import type { Locale } from "../../../../core/schema/Locale.js";

export interface ContactFormData {
	email: string;
	emailMarketingApprovedAt?: string;
	gdprApprovedAt: string;
	message: string;
	name: string;
	pageUrl: string;
	phoneNumber: string;
	locale: Locale;
}

export function readContactFormData(formData: FormData, locale: Locale): ContactFormData {
	const emailMarketingApprovedAt = formData.get("emailMarketingApprovedAt") as string;
	return {
		email: (formData.get("email") as string).trim(),
		...(emailMarketingApprovedAt && { emailMarketingApprovedAt }),
		gdprApprovedAt: formData.get("gdprApprovedAt") as string,
		message: (formData.get("message") as string).trim(),
		name: (formData.get("name") as string).trim(),
		pageUrl: window.location.href,
		phoneNumber: (formData.get("phoneNumber") as string).trim(),
		locale,
	};
}
